// types
import { CountryCode, FlagCode } from '../../../@types';
import { countryCodes, flagCodes } from '../../../@types/unions';
import DOMPurify from 'dompurify';

// mui
import { Box } from '@mui/material';

// props
export interface FlagProps {
	code: CountryCode | FlagCode;
}
export const Flag = ({ code }: FlagProps) => {
	const sanitizedCode = DOMPurify.sanitize(code);

	if (!countryCodes.includes(sanitizedCode as CountryCode) && !flagCodes.includes(sanitizedCode as FlagCode)) {
		return <>123</>;
	}

	return (
		<Box
			component="span"
			sx={{
				'& img': {
					display: 'block',
					width: 'auto',
					height: 18,
				},
			}}>
			<img alt={sanitizedCode} src={`/img/flags/${sanitizedCode.toLowerCase()}.svg`} />
		</Box>
	);
};
